import { Id } from '@bridge/reactEvents';
import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const productApprovalEvents = {
  productApprovalsCreated: new SignalDispatcher(),
  productApprovalChanged: new SimpleEventDispatcher<Id>(),
  productApprovalRejected: new SignalDispatcher(),
  productApprovalAccepted: new SignalDispatcher(),
  productApprovalRevertedToPending: new SignalDispatcher(),
};
